import { theme } from 'antd';
import type { ThemeConfig as AntdThemeConfig } from 'antd/lib/config-provider/context';

import { extractFontFamilies, loadFont, type Theme } from '@eduzz/shared';

import { fetchTheme } from './utils/theme/remoteTheme';

const loadFonts = async (theme: NonNullable<Theme['antd']>) => {
  const fontFamilies = extractFontFamilies(theme);

  for (const font of fontFamilies) {
    await loadFont(font);
  }
};

export default async function createTheme(mode: 'dark' | 'light', motion: boolean): Promise<AntdThemeConfig> {
  const remoteTheme = await fetchTheme();

  if (!remoteTheme) {
    const fallbackAlgorithm = mode === 'dark' ? [theme.darkAlgorithm] : [theme.defaultAlgorithm];
    return { algorithm: fallbackAlgorithm, cssVar: { prefix: 'uizz-antd' } };
  }

  await loadFonts(remoteTheme);

  return {
    algorithm: mode === 'dark' ? [theme.darkAlgorithm] : [theme.defaultAlgorithm],
    token: { ...remoteTheme[mode].token, motion },
    components: remoteTheme[mode].components,
    cssVar: { prefix: 'uizz-antd' }
  };
}
